import { h } from 'preact'
import ErrorMessage from './ErrorMessage'
import Loader from './Loader'
import Project from './Project'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const Projects = (props) => {

  if (props.error) {
    return <ErrorMessage type="posts-error" />
  }

  if (!props.loading && props.projects.length === 0) {
    return <ErrorMessage type="no-results" />
  }

  return (
      <div className="c-projects">

      <div className="c-projects__row">
      {
        props.projects.map((project) => {
          return <Project project={project} key={project.id} language={props.language} />
        })
      }
      </div>

  { props.loading ? (
      <Loader />
  ) : null }

</div>
)
}

export default Projects



// WEBPACK FOOTER //
// ./src/js/news/components/Projects.js